import { useContext, useState, useEffect } from 'react'

// Components
import PageWrapper from 'components/PageWrapper'

// Api
import { setCashout } from 'api/cashout'
import { createExternalAccount } from 'api/bank'
import OTPValidation from 'components/OTPValidation'
import {
  useCashoutResponse,
  useNewTransferStore,
  useSelectedAccountStore
} from 'store'

// context + store
import { MeContext } from 'contexts/me'

import { trackEvent } from 'analytics/trackFunctions'
import { useNavigate } from 'react-router-dom'
import { accentFold, cleanString } from 'utils'

const CashoutOTP = () => {
  const [OTPInput, setOTPInput] = useState(new Array(6).fill(''))
  const [isRequesting, setIsRequesting] = useState(false)

  const [inputStatus, setInputStatus] = useState('waiting')

  const navigate = useNavigate()
  const { me } = useContext(MeContext)

  const amount = useNewTransferStore((state) => state.amount)
  const concept = useNewTransferStore((state) => state.concept)
  const detail = useNewTransferStore((state) => state.detail)
  const selectedAccount = useSelectedAccountStore(
    (state) => state.selectedAccount
  )
  const entityData = useSelectedAccountStore((state) => state.entityData)

  const { updateResponse } = useCashoutResponse()

  const handleConfirm = async () => {
    if (isRequesting) return

    setIsRequesting(true)

    const formattedDetail = cleanString(accentFold(detail))

    const data = {
      amount,
      tax_type: selectedAccount.CVU ? 'CVU' : 'CBU',
      tax_value: selectedAccount.CVU ?? selectedAccount.CBU,
      tax_identification_value: selectedAccount.CUIL.toString(),
      account_holder: selectedAccount.accountHolder,
      bank_name: entityData.bankName,
      concept: concept.name,
      description: formattedDetail
    }

    try {
      const res = await setCashout({
        ...data,
        otp_code: Number(OTPInput.join('')),
        bank_image: entityData.iconURL,
        wallet_internal_account: me.bank.internal_account[0].wallet_account
      })

      if (res.success) {
        if (selectedAccount.comesFromNewAccount) {
          await createExternalAccount({
            bank_code: entityData.bankCode,
            account_holder: selectedAccount.accountHolder,
            cvu: selectedAccount.CVU,
            cbu: selectedAccount.CBU,
            is_owner:
              selectedAccount.CUIL.toString() ===
              me?.profile?.tax_identification_value.toString(),
            tax_identification_value: selectedAccount.CUIL.toString()
          })
        }
        updateResponse(res.data)
        setInputStatus('success')
        setTimeout(() => {
          navigate('/transferencias/transferencia-exitosa', { replace: true })
        }, 5000)
      } else {
        if (res.statusCode === 500) throw new Error('Cashout error')
        setInputStatus('error')
        setOTPInput(new Array(6).fill(''))
      }
    } catch (error) {
      trackEvent({
        eventName: 'bille_error_envio_transferencia',
        props: {
          ...data,
          apiError: JSON.stringify(error)
        }
      })
      navigate('/transferencias/error')
    } finally {
      setIsRequesting(false)
    }
  }

  useEffect(() => {
    trackEvent({
      eventName: 'bille_pantalla_validar_transferencia'
    })
  }, [])

  return (
    <PageWrapper
      viewSelected='/movimientos'
      title='Validar transferencia'
      noTabBar
    >
      <section className='sm:max-w-564 flex flex-col items-center sm:mt-0 mx-auto'>
        <OTPValidation
          inputValue={OTPInput}
          setInputValue={setOTPInput}
          confirmAction={handleConfirm}
          inputStatus={inputStatus}
          isRequesting={isRequesting}
        />
      </section>
    </PageWrapper>
  )
}

export default CashoutOTP
